import "./App.css";
import { useEffect, useState, useLayoutEffect } from "react";
import Header from "./components/Header";
import TabGroup from "./components/TabGroup";
import "../src/css/Grid.css";
import { onAdsConsent } from "./cookieyesConsent";
import "../src/css/Cookie.css";
import Main from "./components/Main";
import GoogleAnalyticsScript from "./components/GoogleAnalyticsScript";
import { useLoaderData } from "react-router-dom";
import ReactPixel from "react-facebook-pixel";
import { postPixel } from "./api/postPixel.js";
import { genericLog } from "./api/genericLog.js";
import Cookies from "js-cookie";
import { ErrorPage2 } from "./error-page";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";

const defaultSocial = "INSTAGRAM";
const nonDefaultSocial = "TIKTOK";
const googleAnalyticsEnabled = process.env.ENABLE_GOOGLE_ANALYTICS === "true";
const getCookieValue = (key) => Cookies.get(key);
const getEventId = (user) => `event_${new Date().getTime()}`;
const cleanString = (s) => (!s ? "" : s);

const isInAppBrowser = (social, userAgent, referrer) => {
  const ua = cleanString(userAgent).toUpperCase();
  const ref = cleanString(referrer).toUpperCase();
  genericLog('ua=',ua, 'referrer=',ref);

  if (social === "TIKTOK") {
      genericLog('TikTokBrowserDetected');
      return (
      ua.includes("TTWEBVIEW") ||
      ua.includes("TIKTOK") ||
      ua.includes("BYTEDANCE") ||
      ref.includes("TIKTOK.COM") ||
      ref.includes("CHIPMUNK")
    );
  }

  if (social === "INSTAGRAM") {
    genericLog(`User Agent: ${userAgent}, Referrer: ${referrer}`);
    if (ua.includes("INSTAGRAM") || ref.includes("INSTAGRAM")) {
      genericLog("InstagramBrowserDetected");
      return true;
    }
  }

  return false;
};

function App() {
  const user = useLoaderData();
  const location = useLocation();
    const [eventId] = useState(() => getEventId(user));

  const determineInitialTab = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const ref = document.referrer;

    if (user.tiktokEnabled && !user.fbEnabled) return "TIKTOK";
    if (user.fbEnabled && !user.tiktokEnabled) return "INSTAGRAM";

    if(isInAppBrowser("INSTAGRAM", ua, ref)) return "INSTAGRAM";
    if(isInAppBrowser("TIKTOK", ua, ref)) return "TIKTOK";

    return defaultSocial;
  };

  const [selectedSource, setSelectedSource] = useState(determineInitialTab);

  const handleTabChange = (source) => {
    setSelectedSource(source);
  };

  useLayoutEffect(() => {
    clearFacebookCookies();
  }, [user]);

  useEffect(() => {
        //initPixel(user, eventId);

        onAdsConsent(() => initPixel(user, eventId));


  }, [user, eventId, location.pathname]);

  const showTabGroup = user.fbEnabled && user.tiktokEnabled;

  if (user.base_subscription === "NONE") {
    return (
      <>
        {googleAnalyticsEnabled && <GoogleAnalyticsScript />}
        <ErrorPage2 />
      </>
    );
  }

  return (
    <>
      {googleAnalyticsEnabled && <GoogleAnalyticsScript />}
      {user.backgroundImageUrl && (
        <div
          className="page-background"
          style={{ backgroundImage: `url("${user.backgroundImageUrl}")` }}
          aria-hidden="true"
        />
      )}
      <Header user={user} />
      {showTabGroup && (
        <TabGroup onTabChange={handleTabChange} activeTab={selectedSource} />
      )}

      <div style={{ display: selectedSource === "INSTAGRAM" ? "block" : "none" }}>
        {user.fbEnabled && <Main user={user} source="INSTAGRAM" />}
      </div>

      <div style={{ display: selectedSource === "TIKTOK" ? "block" : "none" }}>
        {user.tiktokEnabled && <Main user={user} source="TIKTOK" />}
      </div>
    </>
  );
}
/*test*/
const initPixel = async (user, eventId) => {
    console.log("initPixel", user.userId);
  if (user.metaPixelId && user.metaPixelAllowed) {
    ReactPixel.init(user.metaPixelId);
    ReactPixel.trackSingle(user.metaPixelId, "PageView", {eventID: eventId });
    const fbp = await waitForCookie('_fbp');
    const fbc = await waitForCookie('_fbc');
    console.log(`fbp=${fbp}, fbc=${fbc}`);
    postPixel(user.userId, eventId , fbp, fbc);
  } else {
    clearFacebookCookies();
  }
};

const clearFacebookCookies = () => {
  const domain = window.location.hostname === "localhost" ? "localhost" : "gotolinks.com";
  document.cookie = `_fbp=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=None; Secure;`;
  document.cookie = `_fbc=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=None; Secure;`;
};


const waitForCookie = (cookieName, timeout = 2000) => {
  return new Promise((resolve) => {
    const start = Date.now();
    const interval = setInterval(() => {
      const value = Cookies.get(cookieName);
      if (value) {
        clearInterval(interval);
        resolve(value);
      } else if (Date.now() - start > timeout) {
        clearInterval(interval);
        resolve(null);
      }
    }, 100);
  });
};



export default App;